export function isValidZipCode(zip_code, country) {
  // Return bool - True if provided value is a valid zip code
  // based on the country

  var countries = require("localized-countries")(
    require("localized-countries/data/pl")
  );
  var country_code = Object.keys(countries.object()).find(
    key => countries.object()[key] === country
  );
  const postalCodes = require("postal-codes-js");
  return postalCodes.validate(country_code, zip_code) == true;
}
